import React, { ReactNode } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { secondary, primary, statusBlue, statusGreen, statusOrange } from 'helpers/colors';

const themeMui = createTheme({});

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: '#fff' }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: primary.main,
          borderRadius: '10px',
          fontSize: 16,
          padding: 500,
          margin: 500,
          position: 'relative',
          top: 2
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          fontSize: 16,
          padding: 500,
          margin: 500,
          border: '1px solid #cfcfcf'
        }
      }
    },
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          [themeMui.breakpoints.up('lg')]: {
            maxWidth: 'none'
          }
        },
        maxWidthXl: {
          [themeMui.breakpoints.up('lg')]: {
            maxWidth: 'none'
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: 10
        }
      }
    },
    MuiTableFooter: {
      styleOverrides: {
        root: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: '100%'
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          position: 'relative',
          zIndex: 100
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          borderColor: '#585858'
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 16,
          height: 25
        }
      }
    }
  },
  typography: {
    fontFamily: ['"Open Sans"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(',')
  },
  palette: {
    primary: {
      light: primary.light,
      main: primary.main,
      dark: primary.dark,
      contrastText: primary.contrast
    },
    secondary: {
      light: secondary.light,
      main: secondary.main,
      dark: secondary.hover,
      contrastText: secondary.contrast
    },
    info: {
      light: statusBlue.light,
      main: statusBlue.main,
      dark: statusBlue.hover,
      contrastText: primary.contrast
    },
    success: {
      light: statusGreen.light,
      main: statusGreen.main,
      dark: statusGreen.hover,
      contrastText: primary.contrast
    },
    warning: {
      light: statusOrange.light,
      main: statusOrange.main,
      dark: statusOrange.hover,
      contrastText: statusOrange.contrast
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  }
});

function CustomThemeProvider({ children }: Record<string, ReactNode>) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default CustomThemeProvider;
